module.exports = __webpack_public_path__ + "static/img/pic_coop06@2x.2aa9c3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productServices/brandOperation/serviceContent/pic_coop06@2x.png
// module id = 3bfH
// module chunks = 0